/**
 * Version: V0.0.3.0
 * Created: 2026-06-12
 * Updated: 2026-06-13
 * Description: Theme switcher component supporting both standalone state and parent prop sync, mirroring the template theme logic.
 */

import React, { useState, useEffect } from 'react';
import { Sun, Moon } from 'lucide-react';

export default function ThemeSwitcher({ theme, setTheme }) {
  const [localTheme, setLocalTheme] = useState(() => localStorage.getItem('theme') || 'light');

  const activeTheme = theme !== undefined ? theme : localTheme;
  const activeSetTheme = setTheme !== undefined ? setTheme : setLocalTheme;

  useEffect(() => {
    const root = window.document.documentElement;
    if (activeTheme === 'dark') {
      root.classList.add('dark');
      document.body.setAttribute('data-theme', 'dark');
    } else {
      root.classList.remove('dark');
      document.body.setAttribute('data-theme', 'light');
    }
    localStorage.setItem('theme', activeTheme);
    localStorage.setItem('dentiefy-theme', activeTheme);
  }, [activeTheme]);

  const toggleTheme = () => {
    activeSetTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-full text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors"
      aria-label="Toggle theme"
    >
      {activeTheme === 'light' ? <Moon size={20} /> : <Sun size={20} />}
    </button>
  );
}
